export const businessIntelligence = {
  conformity_heatmap: {
    title: "Mapa de calor de conformidade",
    description: "Mapa de calor interativo mostrando níveis de conformidade agregados em todos os locais e temas",
    loading_error: "Falha ao carregar dados de conformidade. Por favor, tente novamente.",
    stats: {
      total_tasks: "Tarefas totais",
      sites_with_data: "Locais com dados",
      themes_with_data: "Temas com dados",
    },
    filters: {
      title: "Filtros",
      year: "Ano",
      all_years: "Todos os anos",
      site: "Local",
      all_sites: "Todos os locais",
      theme: "Tema",
      all_themes: "Todos os temas",
      standard: "Norma",
      all_standards: "Todas as normas",
      assessment: "Avaliação",
      all_assessments: "Todas as avaliações",
      clear_all: "Limpar tudo",
    },
    legend: {
      does_not_meet: "Não atende",
      partially_meets: "Atende parcialmente",
      substantially_meets: "Atende substancialmente",
      fully_meets: "Atende totalmente",
      no_scorable_data: "Sem dados pontuáveis",
    },
    axis_labels: {
      sites: "Locais",
      themes: "Temas",
    },
    avg_conformity_level: "Nível médio de conformidade",
    no_data_message: "Nenhum dado disponível para os filtros selecionados. Tente ajustar seus critérios de filtro.",
  },
};
